// Hobbies/Interests
const hobbiesInterests = [
  'Community Involvement', 'Writing', 'Blogging', 'Learning Languages', 'Photography', 'Travel', 'Sports', 'Music', 'Reading', 'Yoga', 'Art', 'Dance', 'Pet care', 'Gaming'];

// Soft Skills
const softSkills = [
  'Leadership', 'Written communication', 'Flexibility', 'Verbal Communication', 'Detail-oriented', 'Problem-solving', 'Teamwork', 'Imaginatoin', 'Dedication', 'Mindfulness', 'Creativity', 'Patience', 'Compassion', 'Passion', 'Collaborating'
];

// Professional Skills
const professionalSkills = [
  'Negotiation', 'Editing', 'Audience building', 'Translation', 'Adobe Photoshop', 'Foreign languages', 'Heavy lifting', 'Research', 'Audience engagement', 'Physical flexibility', 'Sales', 'Physical stamina', 'Feeding schedules', 'Manual dexterity', 'First-aid'
  // Add more professional skills here
];

// Exporting sections
export const hobbiesSections = [
  { title: 'Hobbies/Interests', skills: hobbiesInterests },
  // { title: 'Soft Skills', skills: softSkills },
  // { title: 'Professional Skills', skills: professionalSkills },
];

export const profSoftSkills = [
  "Problem-Solving", "Adaptability", "Communication", "Teamwork", "Critical Thinking", "Empathy", "Decision-Making", "Creativity", "Analytical Thinking", "Problem Solving", "Attention to Detail", "Negotiation", "Research", "Strategic Planning", "Integrity", "Patience", "Organization", "Leadership", "Team Building"
];

const itSkills = [
  "Java", "JavaScript", "Python", "C++", "C", "SQL", "Network Security", "AWS", "Azure", "NoSQL", ".NET", "System Analysis and Design", "Software Development Life Cycle"];

const healthSkills = [
  "Health Records Management", "Patient Care", "Diagnosis", "Medical Research", "Emergency Response", "Treatment Planning"]

const engineeringSkills = [
  "CAD Design", "Structural Analysis", "Project Management", "Systems Engineering", "Building Information Modeling (BIM)"]

const legalSkills = [
  "Legal Writing", "Contract Law", "Litigation", "Legal Research", "Case Management"]

const bankSkills = [
  "Financial Analysis", "Risk Management", "Budgeting", "Auditing", "Forecasting", "Investment Strategies"]

const caSkills = [
  "Financial Reporting", "Taxation", "Compliance", "Auditing", "Regulatory Knowledge", "Strategic Financial Planning"]

const educationSkills = [
  "Curriculum Development", "Classroom Management", "Educational Assessment", "Lesson Planning", "Student Engagement"]

const hrSkills = [
  "Project Scheduling", "Risk Management", "Resource Allocation", "Employee Relations", "Performance Management"]

const otherBusinessSkills = [
  "Project Scheduling", "Risk Management", "Resource Allocation", "Employee Relations", "Performance Management"]


export const professionSkills = [
  { title: 'Information Technology (IT)', skills: itSkills },
  { title: 'Healthcare and Medicine', skills: healthSkills },
  { title: 'Engineering & Architecture', skills: engineeringSkills },
  { title: 'Law & Legal Services', skills: legalSkills },
  { title: 'Banking, Finance & Business', skills: bankSkills },
  { title: 'Chartered Accountants', skills: caSkills },
  { title: 'Education & Teaching', skills: educationSkills },
  { title: 'Project & Human Resource Management', skills: hrSkills },
  { title: 'Other Businesses', skills: otherBusinessSkills },
]

const informationTechnologyTools = ['Visual Studio Code', 'IntelliJ IDEA', 'Git', 'JIRA', 'Trello', 'Asana', 'MySQL', 'MongoDB', 'PostgreSQL', 'AWS', 'Microsoft Azure', 'Google Cloud Platform', 'GitHub', 'GitLab'];
const healthcareMedicineTools = ['Stethoscope', 'MRI Machines', 'Ultrasound Devices', 'Meditech', 'Allscripts', 'Electronic Health Records (EHR) Systems'];
const engineeringArchitectureTools = ['AutoCAD', 'SolidWorks', 'MS Project', 'MATLAB', 'Tekla', 'ANSYS', 'Navisworks', 'Primavera'];
const lawLegalServicesTools = ['Westlaw', 'LexisNexis', 'Clio', 'Microsoft Word', 'Timeslips'];
const bankingFinanceBusinessTools = ['QuickBooks', 'Sage', 'Xero', 'Bloomberg Terminal', 'SAP', 'Oracle Financial Services', 'SAS', 'MATLAB'];
const charteredAccountantsTools = ['QuickBooks', 'Sage', 'Xero', 'CaseWare', 'IDEA', 'Excel', 'BPC', 'Thomson Reuters ONESOURCE'];
const educationTeachingTools = ['Google Classroom', 'Blackboard', 'Moodle', 'PowerPoint', 'ClassDojo', 'Edmodo', 'Quizlet'];
const projectHumanResourcesManagementTools = ['MS Project', 'Trello', 'Asana', 'BambooHR', 'Slack', 'Microsoft Teams', 'Smartsheet'];
const otherBusinessTools = ['Salesforce', 'HubSpot', 'Zoho CRM', 'SAP', 'Zoom', 'Oracle ERP', 'Microsoft Dynamics', 'Google Analytics', 'Slack', 'Microsoft Teams', 'JDA Software', 'Oracle SCM', 'Calendly', 'Google Forms', 'Tableau', 'Power BI'];

export const professionalTools = [
  { title: 'Information Technology (IT)', skills: informationTechnologyTools },
  { title: 'Healthcare and Medicine', skills: healthcareMedicineTools },
  { title: 'Engineering & Architecture', skills: engineeringArchitectureTools },
  { title: 'Law & Legal Services', skills: lawLegalServicesTools },
  { title: 'Banking, Finance & Business', skills: bankingFinanceBusinessTools },
  { title: 'Chartered Accountants', skills: charteredAccountantsTools },
  { title: 'Education & Teaching', skills: educationTeachingTools },
  { title: 'Project & Human Resource Management', skills: projectHumanResourcesManagementTools },
  { title: 'Other Businesses', skills: otherBusinessTools },
]